import { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useFetch } from '../../hook/useFecth';
import useErrors from '../../hook/useErrors';
import server from '../../services/server';
import Select from 'react-select';
import useDialog from '../../hook/useDialog';
import { useConfirm } from '../../context/BootstrapConfirm';
import { Modal } from 'react-bootstrap';
import { Icon } from '@iconify/react/dist/iconify.js';
// import PaymentSelect from '../PaymentSelect';
import { Link } from 'react-router-dom';
import { PriceInputMasked } from '../masks/PriceInputMasked';
// import { paymentMethod } from '../../helper/PaymentType';
// import TableListCreditsInOrder from '../TableListCreditsInOrder';

import { useState } from 'react';
import { pagamentoTipo } from '../../helper/helpers';
import { formatCurrency } from '../../helper/currency';

function OrderPaymentModal({ data, mutate }) {
    const { setErrors, toast } = useErrors();
    const { open: show, handleClose } = useDialog('payment');
    const confirm = useConfirm();
    const [selectedCredit, setSelectedCredit] = useState(null);
    // const { data: credits, mutate: mutateCredits } = useFetch(`orders/${data?.id}/credits`);


    const { getFieldProps, errors, isSubmitting, isValid, handleSubmit, handleBlur, touched, values, setValues, setFieldValue, resetForm } =
        useFormik({
            initialValues: {
                action: 'create',
                id: '',
                valorTotal: '',
                tipo: '',
                parcela: '',
            },
            // validationSchema: Yup.object().shape({
            //     product_id: Yup.string().required('Informe o produto'),
            // }),
            validateOnMount: true,
            validateOnChange: true,
            onSubmit: async (values, { setSubmitting, resetForm }) => {
                try {
                    setSubmitting(true);
                    if (values.action === 'update') {
                        await server.post(`pedido/${data?.id}/pagamento`, values);
                        toast.success('Item adicionado com sucesso.');
                    };
                    if (values.action === 'pagamento') {
                        await server.patch(`pedido/${data?.id}/pagamento`, { ...values, ...selectedCredit });
                        // await mutateCredits();
                        setFieldValue({ method: '' });
                        setSelectedCredit(null);
                        toast.success('Pagamento adicionado com sucesso.');
                    };
                    if (values.action === 'closeOrder') {
                        await server.patch(`orders/${data?.id}`);
                        handleClose()
                    };
                    await mutate();
                    resetForm();
                    // handleClose();
                    setSubmitting(false);
                    // resetForm();
                } catch (error) {
                    setSubmitting(false);
                    console.log('Wesley ', error);
                    setErrors(error);
                };
            },
        });

    const remainingValue = ((data?.valorTotal - data?.totalRecebido).toFixed(2)) || 0.0;
    useEffect(() => {
        if (Boolean(data)) {
            setValues(
                {
                    ...data,
                    ...values,
                    valorTotal: remainingValue || 0,
                    action: 'update',
                },
                true,
            );
        }
    }, [data]);

    function handlePaymentWithCredit() {
        setFieldValue('action', 'pagamento', true);
        handleSubmit();
    };

    function handlePayment() {
        setFieldValue('action', 'update', true);
        handleSubmit();
    };

    async function handleCloseOrder() {
        try {
            await confirm({ message: 'Tem certeza que deseja fechar o pedido sem pagamento ??' });
            setFieldValue('action', 'closeOrder', true);
            handleSubmit();
        } catch (e) { }
    };

    async function handleRemove() {
        try {
            await confirm({ message: 'Você tem certeza que está removendo?' });
            setFieldValue('action', 'delete');
            handleSubmit();
        } catch (e) { }
    }

    console.log("Dados do pedido", data)
    const cartaoCreditoSelecionado = ['cartaoCredito'].includes(values?.tipo)
    return (
        <>
            <Modal size="lg" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title className="text-md"> Detalhes pagamento </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-20 mt-10">
                        {/* Total Bruto */}
                        <div className="col-md-4">
                            <div className="d-flex align-items-center gap-3 mb-3">
                                <div className="w-40-px h-40-px radius-8 flex-shrink-0 bg-info-50 d-flex justify-content-center align-items-center">
                                    <span className="w-40-px h-40-px bg-success-main text-white d-flex justify-content-center align-items-center radius-8">
                                        <Icon icon="mdi:cart-check" width="24" height="24" />
                                    </span>
                                </div>
                                <div className="flex-grow-1">
                                    <h6 className="text-md mb-0 fw-normal">Total Bruto:</h6>
                                    <span className="text-sm text-secondary-light fw-normal">
                                        {formatCurrency(data?.valorTotal)}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Total Recebido */}
                        <div className="col-md-4">
                            <div className="d-flex align-items-center gap-3 mb-3">
                                <div className="w-40-px h-40-px radius-8 flex-shrink-0 bg-success-50 d-flex justify-content-center align-items-center">
                                    <span className="w-40-px h-40-px bg-success-main text-white d-flex justify-content-center align-items-center radius-8">
                                        <Icon icon="mdi:cash-check" width="24" height="24" />
                                    </span>
                                </div>
                                <div className="flex-grow-1">
                                    <h6 className="text-md mb-0 fw-normal">Total Recebido:</h6>
                                    <span className="text-sm text-secondary-light fw-normal">
                                        {formatCurrency(data?.totalRecebido)}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Total a Receber */}
                        <div className="col-md-4">
                            <div className="d-flex align-items-center gap-3 mb-3">
                                <div className="w-40-px h-40-px radius-8 flex-shrink-0 bg-warning-50 d-flex justify-content-center align-items-center">
                                    <span className="w-40-px h-40-px bg-warning-main text-white d-flex justify-content-center align-items-center radius-8">
                                        <Icon icon="mdi:cash-clock" width="24" height="24" />
                                    </span>
                                </div>
                                <div className="flex-grow-1">
                                    <h6 className="text-md mb-0 fw-normal">Total a Receber:</h6>
                                    <span className="text-sm text-secondary-light fw-normal">
                                        {formatCurrency((data?.valorTotal || 0) - (data?.totalRecebido || 0))}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </div>

                    {data?.pagamentos?.map(pagamento => (
                        <>
                            <div className="col-xxl-12 mb-3 col-sm-12">
                                <div className="card px-3 py-1 shadow-none radius-8 border h-100 bg-gradient-start-1">
                                    <div className="card-body p-0">
                                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 ">
                                            <div className="d-flex py-2 ">
                                                <div className="w-64-px  radius-16 bg-base-50 d-flex justify-content-center align-items-center me-20">
                                                    <span className="mb-0 w-40-px h-40-px bg-success-main flex-shrink-0 text-white d-flex justify-content-center align-items-center radius-8 h6 mb-0">
                                                        <Icon icon="streamline:bag-dollar-solid" className="icon" />
                                                    </span>
                                                </div>
                                                <div className="d-flex col-12   align-items-center  justify-content-between  gap-80">
                                                    <div>
                                                        <span className=" gap-4 fw-medium text-secondary-light text-sm">Recebido</span>
                                                        <h6 className="fw-semibold text-sm my-1">
                                                            {' '}
                                                            {formatCurrency(pagamento?.valor)}
                                                            {/* <span>{Boolean(pag?amento.parcela) ? ` / ${pagamento.parcela} = ${pagamento.valor / pagamento.parcela}` : ''  }</span> */}
                                                        </h6>
                                                    </div>
                                                    <div className="gap-0 mb-0  py-0 px-5">
                                                        <div className="text-sm gap-3 ">
                                                            Forma de pagamento :
                                                            <span className="  px-1 rounded-2 fw-medium text-success-main text-sm">
                                                                {` ${pagamentoTipo[pagamento.tipo]}`} 
                                                                { Boolean(pagamento?.parcela) && <> { `${pagamento.parcela}X`} </>}
                                                            </span>
                                                        </div>
                                                        <div className="text-sm mb-0 ">
                                                            Data do pagamento:
                                                            <span className="px-1 rounded-2 fw-light text-info-main text-sm">
                                                                {new Date(pagamento?.dataCriacao).toLocaleString()}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ))}

                    {Boolean(remainingValue) && (
                        <>
                            <form id="submitPayment" onSubmit={handleSubmit}>
                                <div className="row mt-4  g-3">
                                    {/* Tipo de Pagamento */}
                                    <div className="col-md-4">
                                        <PaymentSelect disabled={['CLOSED'].includes(data?.status)  || data.totalRecebido >= data?.valorTotal} getFieldProps={getFieldProps} />
                                    </div>
                                    {/* Valor */}

                                    <div className={cartaoCreditoSelecionado ? 'col-md-4' : 'col-md-6'}>
                                        <label className="form-label fw-medium text-sm">Valor</label>
                                        <PriceInputMasked
                                            disabled={!values.tipo || data.totalRecebido >=  data?.valorTotal}
                                            {...getFieldProps('valorTotal')}
                                            className="form-control border border-neutral-200 radius-8"
                                            id="value"
                                            placeholder="Ex: R$ 1.500,00"
                                        />
                                    </div>
                                    {['cartaoCredito'].includes(values?.tipo) && (

                                        <div className="mb-20 col-xxl-3 col-xl-3 col-md-6 col-sm-12">
                                            <label htmlFor="parcela" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                                Parcelas
                                                <span className="text-danger-600">*</span>{' '}
                                                {touched.parcela && errors.parcela && <span classname="text-danger-600">{errors.parcela}</span>}
                                            </label>
                                            <input type="text" className="form-control radius-8" id="parcela" {...getFieldProps('parcela')} />
                                        </div>
                                    )}
                                </div>

                            </form>


                        </>
                    )}
                </Modal.Body>

                <Modal.Footer className="pt-4 px-0 border-top d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1 ms-3">
                        {/* {credits?.totalCredits > 0 && (
                            <span className="text-success fw-semibold">{`Usuário com total de ${credits?.totalCredits} crédito disponível`}</span>
                        )} */}
                    </div>

                    <div>
                        {/* {!Boolean(data?.pagamentos?.length) && (
                            <>
                                <button
                                    form="submitPayment"
                                    type="button"
                                    className="btn btn-danger me-3 border border-danger-600 text-md radius-8"
                                    disabled={isSubmitting || ['CLOSED'].includes(data?.status)}
                                    onClick={() => handleCloseOrder()}
                                >
                                    <Icon icon="ic:baseline-close" width="24" height="24" />
                                    Fechar Pedido
                                </button>
                            </>
                        )} */}

                        {values.tipo !== 'credit' && (
                            <button
                                form="submitPayment"
                                type="submit"
                                className="btn btn-success me-3 border border-success-600 text-md radius-8"
                                disabled={isSubmitting || !values.tipo}
                                onClick={() => handlePayment()}
                            >
                                <Icon icon="mdi:attach-money" width="24" height="24" />
                                Adicionar
                            </button>
                        )}


                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default OrderPaymentModal;



const PaymentSelect = ({ getFieldProps, disabled }) => {
    const [tipoPagamento, setTipoPagamento] = useState('');

    const handleChange = (event) => {
        setTipoPagamento(event.target.value);
    };

    return (
        <div className="mb-3">
            <label htmlFor="payment" className="form-label fw-bold">
                Forma de Pagamento:
            </label>
            <select
                id="payment"
                className="form-select"
                value={tipoPagamento}
                onChange={handleChange}
                {...getFieldProps('tipo')}
                disabled={disabled}
            >
                <option value={null}>Selecione</option>
                <option value="dinheiro">Dinheiro</option>
                <option value="cartaoCredito">Cartão de Crédito</option>
                <option value="cartaoDebito">Cartão de Débito</option>
                <option value="pix">Pix</option>

            </select>

            {/* {tipoPagamento && (
          <div className="mt-2 alert alert-info p-2">
            Tipo selecionado: <strong>{tipoPagamento}</strong>
          </div>
        )} */}
        </div>
    );
};
